var React = require('react');

function Cloud (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.846 37.94c-7.854-2.11-10.48-11.616-4.784-17.313 2.966-2.966 7.224-3.858 11.243-2.354 1.364.51 2.806 1.387 4.752 2.89 1.214.938 1.706.99 2.49.258 1.023-.952.772-1.893-.904-3.386-2.669-2.38-6.727-4.012-9.97-4.012H9.12l.184-.86c.95-4.446 4.76-9.135 9.167-11.28C20.728.782 23.83 0 25.929 0c3.464 0 8.128 1.69 10.793 3.912 1.27 1.06 3.396 3.385 3.396 3.715 0 .102-.59.396-1.31.652-1.563.555-5.068 2.847-5.825 3.809-.719.914-.697 2.058.05 2.581.933.653 1.564.495 3.119-.78 2.695-2.211 5.073-3.041 8.715-3.041 3.932 0 6.613.887 9.443 3.124 3.658 2.892 5.668 8.936 4.492 13.512-1.373 5.346-5.889 9.647-11.125 10.596-1.03.186-7.916.279-19.976.267-15.33-.014-18.649-.082-19.855-.407z","fill":"currentColor"}));
}

Cloud.defaultProps = {"viewBox":"0 0 59.138 38.348"};

module.exports = Cloud;

Cloud.default = Cloud;
